import { DataLayer } from '@grandvisionhq/analytics';

const pushSolutionsChangeQuantityEvent = ({ quantity , quantityChange , purchaseType  })=>{
    const interactionType = quantityChange === 'increase' ? 'solutions quantity increase' : 'solutions quantity decrease';
    DataLayer.pushEvent({
        event: 'click_solution_pdp',
        site_feature: 'solution_pdp',
        interaction_type: interactionType,
        purchase_type: purchaseType,
        quantity
    });
};
const pushContactLensesChangeQuantityEvent = ({ quantity , purchaseType , eyeSide  })=>{
    DataLayer.pushEvent({
        event: 'click_contact_lenses_pdp',
        site_feature: 'contact_lenses_pdp',
        interaction_type: 'quantity_change',
        purchase_type: purchaseType,
        eyeSide,
        quantity
    });
};

export { pushContactLensesChangeQuantityEvent, pushSolutionsChangeQuantityEvent };
//# sourceMappingURL=change-quantity-events.js.map
